
import axios from '@/utils/request'
// Pda管理 - 激活码列表
export const deviceList = (params) => {
    return axios.request({
        url: 'pda/activeCode',
        method: 'get',
        params
    })
};
// Pda管理 - 创建激活码
export const createDeviceCode = (data) => {
    return axios.request({
        url: 'pda/activeCode',
        method: 'post',
        data
    })
};
// Pda管理 - 删除激活码
export const delDeviceCode = (id) => {
    return axios.request({
        url: 'pda/activeCode/' + id,
        method: 'DELETE',
    })
};
// Pda管理 - 激活码操作日志列表
export const deviceLogs = (params) => {
    return axios.request({
        url: 'pda/activeCode',
        method: 'get',
        params
    })
};